import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { DataGridPro } from "@mui/x-data-grid-pro";
import {
  columnsViewDetail,
  columnsViewFund,
} from "../../../helpers/columnsFunds";
import { EditContributions } from "./EditContributions";
import { selectContribution } from "../../../../store/contributions/contributionSlice";
import { deleteInvestmentFund } from "../../../helpers/investmentFunds";
import { TableLayoutWithDetail } from "../../../layout/TableLayoutWithDetail";
import { Stack } from "@mui/material";

export const ViewFundsTable = ({
  rows,
  setReloadData,
  distributionList,
  totalAmount,
}) => {
  const { t } = useTranslation("global");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dispatch = useDispatch();
  const [openEdit, setOpenEdit] = useState(false);

  const onEditClick = (e) => {
    dispatch(selectContribution(e.row));
    setOpenEdit(true);
  };

  const onDeleteClick = async (e) => {
    await deleteInvestmentFund(
      e,
      t("delete.successMsg"),
      t("delete.errorMsg"),
      t("delete.cancelButton"),
      t("delete.confirmButton"),
      t("delete.deleteConfirm")
    );
    setReloadData((prevState) => !prevState);
  };

  const columns = columnsViewFund(t, onDeleteClick, onEditClick);

  const ViewDetails = useCallback(
    (investment) => {
      return (
        <Stack>
          <DataGridPro
            density="compact"
            autoHeight
            columns={columnsViewDetail(t, investment, totalAmount)}
            rows={distributionList}
            sx={{ flex: 1 }}
            hideFooter
          />
        </Stack>
      );
    },
    [t, distributionList, totalAmount]
  );

  return (
    <>
      <TableLayoutWithDetail
        rows={rows}
        columns={columns}
        title="viewFundsAdmin"
        name={searchParams.get("name")}
        detail={ViewDetails}
      />
      {
        // (userToAction.startup !== '' && openEdit) &&
        openEdit && (
          <EditContributions
            setHidden={setOpenEdit}
            setReloadData={setReloadData}
          />
        )
      }
    </>
  );
};
